<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { useTransferStore } from "@/store/transferStore";
import socket from "@/services/socket";

import moment from "moment";

import { ref } from "vue";

/**
 * Dashboard Component
 */
export default {
  setup() {
    const doesApproveOpen = ref(false);
    const doesRejectOpen = ref(false);
    const transferStore = useTransferStore();

    return {
      doesApproveOpen,
      doesRejectOpen,
      transferStore,
    };
  },
  page: {
    title: "transfers",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "transfers",
      items: [
        {
          text: "Menu",
          href: "/",
        },
        {
          text: "transfers",
          active: true,
        },
        {
          text: "Un transfers",
          active: true,
        },
      ],
      transfer: {},
      reason: "",
      pay_id: "",
      pay_date: "",
      id: "",
      loading: false,
      errors: [],
    };
  },
  methods: {
    async getItem() {
      if (!this.transferStore.info) {
        await this.transferStore.loadOne(this.id, true).then((data) => {
          this.transfer = data;
        });
      } else {
        this.transfer = this.transferStore.info;
      }

      socket.on("transfers-update", (data) => {
        if (data?.id == this.transfer.id) {
          this.transferStore.updateOne(data);
          this.transferStore.updateInfo(data);

          this.transfer = this.transferStore.info;
        }
      });
    },

    async refresh() {
      await this.transferStore.loadOne(this.id, true).then((data) => {
        this.transfer = data;
      });
    },

    convertDate(date) {
      return (
        moment.utc(date).format("DD/MM/YYYY ") + " à " + moment.utc(date).format(" H:mm")
      );
    },
    initItem(transfer, action = "edit") {
      this.transfer = transfer;
      this.initData(transfer);
      if (action == "delete") {
        this.doesDeleteOpen = true;
      } else {
        this.doesEditOpen = true;
      }
    },
    initData(item = null) {
      this.rate = item != null ? item.rate : "";
      this.to_id = item != null ? item.to.id : "";
      this.from_id = item != null ? item.from.id : "";
    },

    needToFinish() {
      if (this.transfer.receiveStatus != "success") {
        return false;
      }
      if (this.transfer.sendStatus == "success") {
        return false;
      }
      if (
        this.transfer.status == "pending" ||
        this.transfer.status == "received" ||
        this.transfer.status == "sending"
      ) {
        return true;
      } else {
        return false;
      }
    },

    async tryToFinish() {
      await this.transferStore.tryFinish(this.id, true).then((data) => {
        
        this.transfer = this.transferStore.info?? data;
      });
    },

    async toManual() {
      await this.transferStore.toManual(this.id, true).then((data) => {
        this.transfer = this.transferStore.info ?? data;
      });
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getItem();
  },
  watch: {
    doesAddOpen: function () {
      this.errors = [];
      if (!this.doesAddOpen) {
        this.initData(null);
      }
    },
    doesEditOpen: function () {
      this.errors = [];
      if (!this.doesEditOpen) {
        this.initData(null);
        this.transfer = null;
      }
    },
    doesDeleteOpen: function () {
      if (!this.doesDeleteOpen) {
        this.initData(null);
        this.transfer = null;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <h4 class="card-title d-flex justify-content-between align-items-center">
      Transfer details

      <span>
        <button @click="$router.back()" class="btn btn-secondary btn-sm mb-3">
          Back
        </button>

        <button
          class="btn btn-primary btn-sm mb-3 ms-2"
          @click="tryToFinish()"
          v-if="needToFinish()"
        >
          Finish
        </button>

        <button
          class="btn btn-primary btn-sm mb-3 ms-2"
          @click="toManual()"
          v-if="needToFinish()"
        >
          To Manual
        </button>

        <button class="btn btn-primary btn-sm mb-3 ms-2" @click="refresh()">
          Refresh
        </button>
      </span>
    </h4>

    <div class="row g-4 mt-3" v-if="transfer?.id">
      <div class="col-lg-12">
        <h4 class="card-title text-danger">Sender</h4>
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-md-3">
                <dl>
                  <dt>Nom de Famille</dt>
                  <dd>{{ transfer?.sender?.lastName }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Prénom(s)</dt>
                  <dd>{{ transfer?.sender?.firstName }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Email</dt>
                  <dd>{{ transfer?.sender?.email }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Le compte</dt>
                  <dd>
                    <img
                      :src="transfer.sender?.profile"
                      :alt="transfer.sender.lastName"
                      style="height: 35px; width: 35px"
                      class="border rounded-circle"
                    />
                    <router-link :to="'/users/' + transfer?.sender?.id">
                      Visiter le compte
                    </router-link>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-12">
          <h4 class="card-title text-danger">Receiver</h4>
          <div class="card">
            <div class="card-body">
              <div class="row mt-4">
                <div class="col-md-3">
                  <dl>
                    <dt>Nom de Famille</dt>
                    <dd>
                      {{ transfer?.receiver?.lastName ?? transfer.name?.split(" ")[0] }}
                    </dd>
                  </dl>
                </div>
                <div class="col-md-3">
                  <dl>
                    <dt>Prénom(s)</dt>
                    <dd>
                      {{
                        transfer?.receiver?.firstName ??
                        transfer.name?.replace(transfer.name?.split(" ")[0], "")
                      }}
                    </dd>
                  </dl>
                </div>
                <div class="col-md-3">
                  <dl>
                    <dt>Email</dt>
                    <dd>{{ transfer?.receiver?.email }}</dd>
                  </dl>
                </div>
                <div class="col-md-3">
                  <dl>
                    <dt>Le compte</dt>

                    <dd v-if="transfer.receiver">
                      <img
                        :src="transfer.receiver?.profile"
                        :alt="transfer?.receiver?.lastName"
                        style="height: 35px; width: 35px"
                        class="border rounded-circle"
                      />
                      <router-link :to="'/users/' + transfer?.sender?.id">
                        Visiter le compte
                      </router-link>
                    </dd>
                    <dd v-else></dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-12">
          <h4 class="card-title text-danger">From AccountNumber</h4>
          <div class="card">
            <div class="card-body">
              <div class="row mt-4">
                <div class="col-md-3">
                  <dl>
                    <dt>Method(Type)</dt>
                    <dd>
                      {{ transfer?.fromMethod?.method?.name ?? "-" }} (
                      {{ transfer?.fromAccountNumber?.type ?? "-" }})
                    </dd>
                  </dl>
                </div>
                <div class="col-md-3">
                  <dl>
                    <dt>Account</dt>
                    <dd>
                      {{ transfer?.fromAccountNumber?.number ?? transfer.fromAccount }}
                    </dd>
                  </dl>
                </div>
                <div class="col-md-3">
                  <dl>
                    <dt>Status</dt>
                    <dd>{{ transfer?.fromAccountNumber?.status ?? "-" }}</dd>
                  </dl>
                </div>

                <div class="col-md-3">
                  <dl>
                    <dt>Date de crétion</dt>
                    <dd>{{ convertDate(transfer?.fromAccountNumber?.createdAt) }}</dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-12">
          <h4 class="card-title text-danger">To AccountNumber</h4>
          <div class="card">
            <div class="card-body">
              <div class="row mt-4">
                <div class="col-md-3">
                  <dl>
                    <dt>Method(Type)</dt>
                    <dd>
                      {{ transfer?.toMethod?.method?.name }} (
                      {{ transfer?.toAccountNumber?.type ?? "-" }})
                    </dd>
                  </dl>
                </div>
                <div class="col-md-3">
                  <dl>
                    <dt>Account</dt>
                    <dd>{{ transfer?.toAccountNumber?.number ?? transfer.toAccount }}</dd>
                  </dl>
                </div>
                <div class="col-md-3">
                  <dl>
                    <dt>Phone</dt>
                    <dd>{{ transfer?.phone ?? "-" }}</dd>
                  </dl>
                </div>
                <div class="col-md-3">
                  <dl>
                    <dt>Status</dt>
                    <dd>{{ transfer?.toAccountNumber?.status ?? "-" }}</dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <h4 class="card-title text-danger">Transfer</h4>
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-md-4">
                <dl>
                  <dt>Date transfer</dt>
                  <dd>{{ convertDate(transfer?.createdAt) }}</dd>
                </dl>
              </div>
              <div class="col-md-4">
                <dl>
                  <dt>Name transfer</dt>
                  <dd>{{ transfer?.name ?? "-" }}</dd>
                </dl>
              </div>

              <div class="col-md-4">
                <dl>
                  <dt>Converted Amount</dt>
                  <dd>{{ transfer?.convertedAmount ?? "-" }}</dd>
                </dl>
              </div>
              <div class="col-md-4">
                <dl>
                  <dt>Gain</dt>
                  <dd>
                    {{ transfer?.gain ?? "-" }}
                  </dd>
                </dl>
              </div>
              <div class="col-md-4">
                <dl>
                  <dt>Online Rate</dt>
                  <dd>
                    {{ transfer?.onlineRate ?? "-" }}
                  </dd>
                </dl>
              </div>

              <div class="col-md-4">
                <dl>
                  <dt>Téléphone</dt>
                  <dd>
                    {{ transfer?.phone ?? "-" }}
                  </dd>
                </dl>
              </div>
              <div class="col-md-4">
                <dl>
                  <dt>Rate</dt>
                  <dd>
                    {{ transfer?.rate ?? "-" }}
                  </dd>
                </dl>
              </div>

              <div class="col-md-4">
                <dl>
                  <dt>Sent Amount</dt>
                  <dd>
                    {{ transfer?.sentAmount ?? "-" }}
                    {{ transfer?.conversion?.to?.currency.code }}
                  </dd>
                </dl>
              </div>
              <div class="col-md-4">
                <dl>
                  <dt>Received Amount</dt>
                  <dd>
                    {{ transfer?.receivedAmount ?? "-" }}
                    {{ transfer?.conversion?.to?.currency.code }}
                  </dd>
                </dl>
              </div>

              <div class="col-md-4">
                <dl>
                  <dt>Send Rate</dt>
                  <dd>
                    {{ transfer?.sendRate ?? "-" }}
                  </dd>
                </dl>
              </div>
              <div class="col-md-4">
                <dl>
                  <dt>Send Rate</dt>
                  <dd>
                    {{ transfer?.sendStatus ?? "-" }}
                  </dd>
                </dl>
              </div>
              <div class="col-md-4" v-if="transfer?.receiveId">
                <dl>
                  <dt>Receive Status</dt>
                  <dd>
                    {{ transfer?.receiveStatus ?? "-" }}
                  </dd>
                </dl>
              </div>
              <div class="col-md-4" v-if="transfer?.receiveId">
                <dl>
                  <dt>Receive Id</dt>
                  <dd>{{ transfer?.receiveId ?? "-" }}</dd>
                </dl>
              </div>

              <div class="col-md-4" v-if="transfer?.sendId">
                <dl>
                  <dt>Send Status</dt>
                  <dd>
                    {{ transfer?.sendStatus ?? "-" }}
                  </dd>
                </dl>
              </div>
              <div class="col-md-4" v-if="transfer?.sendId">
                <dl>
                  <dt>Send Id</dt>
                  <dd>{{ transfer?.sendId ?? "-" }}</dd>
                </dl>
              </div>

              <div class="col-md-4">
                <dl>
                  <dt>Rounded</dt>
                  <dd>
                    {{ transfer?.rounded ?? "" }}
                    {{ transfer?.conversion?.from?.currency?.code }}
                  </dd>
                </dl>
              </div>
              <div class="col-md-4">
                <dl>
                  <dt>From Method</dt>
                  <dd>
                    {{ transfer?.fromMethod?.name ?? "-" }}
                  </dd>
                </dl>
              </div>
              <div class="col-md-4">
                <dl>
                  <dt>To Method</dt>
                  <dd>
                    {{ transfer?.toMethod?.name ?? "-" }}
                  </dd>
                </dl>
              </div>

              <div class="col-md-4">
                <dl>
                  <dt>IP</dt>
                  <dd>
                    {{ transfer?.ip ?? "-" }}
                  </dd>
                </dl>
              </div>

              <div class="col-md-4">
                <dl>
                  <dt>Devise</dt>
                  <dd>
                    {{ transfer?.userAgent ?? "-" }}
                  </dd>
                </dl>
              </div>

              <div class="col-md-4">
                <dl>
                  <dt>Location</dt>
                  <dd>
                    {{ transfer?.location ?? "-" }}
                  </dd>
                </dl>
              </div>

              <div class="col-md-4">
                <dl>
                  <dt>Code transfer</dt>
                  <dd>{{ transfer?.code ?? "-" }}</dd>
                </dl>
              </div>
              <div class="col-md-4">
                <dl>
                  <dt>Status transfer</dt>
                  <dd>
                    <span
                      v-if="transfer.status == 'error'"
                      class="badge badge-pill badge-soft-danger font-size-11"
                    >
                      {{ transfer.status }}
                    </span>
                    <span
                      v-if="transfer.status !== 'error'"
                      class="badge badge-pill badge-soft-success font-size-11"
                    >
                      {{ transfer.status }}
                    </span>
                  </dd>
                </dl>
              </div>

              <template v-if="transfer?.description">
                <div class="col-md-12">
                  <dl>
                    <dt>A Propos</dt>
                    <dd>
                      {{ transfer?.description }}
                    </dd>
                  </dl>
                </div>
              </template>

              <template v-if="transfer?.reason">
                <div class="col-md-12">
                  <dl>
                    <dt>Raison du rejet</dt>
                    <dd>
                      {{ transfer?.reason }}
                    </dd>
                  </dl>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12" v-if="transfer?.user_pay_id">
        <h4 class="card-title text-danger">Preuve du client</h4>
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-md-4">
                <dl>
                  <dt>Id Du Paiement</dt>
                  <dd>{{ transfer?.user_pay_id }}</dd>
                </dl>
              </div>
              <div class="col-md-4">
                <dl>
                  <dt>Date de Paiement</dt>
                  <dd>{{ transfer?.user_pay_date }}</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
        <div
          class="hstack mb-4"
          v-if="transfer?.status == 'PROUVEE' || transfer?.status == 'EN COURS'"
        >
          <button class="btn btn-success" @click="doesApproveOpen = true">
            Approuver
          </button>
          <button class="btn btn-danger ms-4" @click="doesRejectOpen = true">
            Réjéter
          </button>
        </div>
      </div>

      <div class="col-lg-12" v-if="transfer?.status == 'TRANSFERER'">
        <h4 class="card-title text-danger">Preuve de PayBuistraPay</h4>
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-md-4">
                <dl>
                  <dt>Id Du Paiement</dt>
                  <dd>{{ transfer?.pay_id }}</dd>
                </dl>
              </div>
              <div class="col-md-4">
                <dl>
                  <dt>Date de Paiement</dt>
                  <dd>{{ convertDate(transfer?.pay_date) }}</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12" v-if="transfer?.receive">
        <h4 class="card-title text-danger">Manual Payment</h4>
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-md-3">
                <dl>
                  <dt>User</dt>
                  <dd>{{ transfer?.receive?.idOfGetter ?? "-" }}</dd>
                </dl>
              </div>

              <div class="col-md-3">
                <dl>
                  <dt>Agent</dt>
                  <dd>{{ transfer?.receive?.idOfAgent }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Account</dt>
                  <dd>{{ transfer?.receive?.idOfAccount }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>receipt</dt>
                  <dd v-if="transfer?.receive?.proof">
                    <a :href="transfer?.receive?.proof" target="_blank">{{
                      transfer?.receive?.proof ?? "-"
                    }}</a>
                  </dd>
                  <dd v-else></dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Refound</dt>
                  <dd v-if="transfer?.receive?.proof">
                    <a :href="transfer?.receive?.refound" target="_blank">{{
                      transfer?.receive?.refound ?? "-"
                    }}</a>
                  </dd>
                  <dd v-else></dd>
                </dl>
              </div>
              <div
                v-for="(receipt, i) in transfer.receive.receipts"
                :key="receipt"
                class="col-md-3"
              >
                <dl>
                  <dt>Brouillon {{ i + 1 }}</dt>
                  <dd v-if="transfer?.receive?.proof">
                    <a :href="receipt" target="_blank">{{ receipt ?? "-" }}</a>
                  </dd>
                  <dd v-else></dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>name</dt>
                  <dd>{{ transfer?.receive?.name ?? "-" }}</dd>
                </dl>
              </div>

              <div class="col-md-3">
                <dl>
                  <dt>payId</dt>
                  <dd>{{ transfer?.receive?.payId ?? "-" }}</dd>
                </dl>
              </div>

              <div class="col-md-3">
                <dl>
                  <dt>Old</dt>
                  <dd>{{ transfer?.receive?.olds?.join(" && ") ?? "-" }}</dd>
                </dl>
              </div>

              <div class="col-md-3">
                <dl>
                  <dt>Leave</dt>
                  <dd>
                    {{ transfer?.receive?.leave }}
                    {{ transfer.exchange?.from?.symbol ?? "" }}
                  </dd>
                </dl>
              </div>

              <div class="col-md-3">
                <dl>
                  <dt>Surplus</dt>
                  <dd>
                    {{ transfer?.receive?.surplus }}
                    {{ transfer.exchange?.from?.symbol ?? "" }}
                  </dd>
                </dl>
              </div>

              <div class="col-md-3">
                <dl>
                  <dt>topics</dt>
                  <dd>{{ transfer?.receive?.topics ?? "-" }}</dd>
                </dl>
              </div>

              <div class="col-md-3">
                <dl>
                  <dt>confirmedAt</dt>
                  <dd>{{ transfer?.receive?.confirmedAt ?? "not confirm" }}</dd>
                </dl>
              </div>

              <div class="col-md-3">
                <dl>
                  <dt>cancelledAt</dt>
                  <dd>{{ transfer?.receive?.cancelledAt ?? "-" }}</dd>
                </dl>
              </div>

              <div class="col-md-3">
                <dl>
                  <dt>payedAt</dt>
                  <dd>{{ transfer?.receive?.payedAt ?? "-" }}</dd>
                </dl>
              </div>

              <div class="col-md-3">
                <dl>
                  <dt>provenAt</dt>
                  <dd>{{ transfer?.receive?.provenAt ?? "-" }}</dd>
                </dl>
              </div>

              <div class="col-md-3">
                <dl>
                  <dt>code</dt>
                  <dd>{{ transfer?.receive?.id ?? "-" }}</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12" v-if="transfer?.send">
        <h4 class="card-title text-danger">Manual Payout</h4>
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-md-3">
                <dl>
                  <dt>Agent (user)</dt>
                  <dd>
                    {{ transfer?.send?.idOfAgent }} (
                    {{ transfer?.send?.idOfGetter ?? "-" }})
                  </dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Account</dt>
                  <dd>{{ transfer?.send?.idOfAccount }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>receipt</dt>
                  <dd v-if="transfer?.send?.proof">
                    <a :href="transfer?.send?.proof">{{
                      transfer?.send?.proof ?? "-"
                    }}</a>
                  </dd>
                  <dd v-else></dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>name</dt>
                  <dd>{{ transfer?.send?.name ?? "-" }}</dd>
                </dl>
              </div>

              <div class="col-md-3">
                <dl>
                  <dt>payId</dt>
                  <dd>{{ transfer?.send?.payId ?? "-" }}</dd>
                </dl>
              </div>

              <div class="col-md-3">
                <dl>
                  <dt>topics</dt>
                  <dd>{{ transfer?.send?.topics?.join(" | ") ?? "-" }}</dd>
                </dl>
              </div>

              <div class="col-md-3">
                <dl>
                  <dt>confirmedAt</dt>
                  <dd>{{ transfer?.send?.confirmedAt ?? "not confirm" }}</dd>
                </dl>
              </div>

              <div class="col-md-3">
                <dl>
                  <dt>cancelledAt</dt>
                  <dd>{{ transfer?.send?.cancelledAt ?? "-" }}</dd>
                </dl>
              </div>

              <div class="col-md-3">
                <dl>
                  <dt>payedAt</dt>
                  <dd>{{ transfer?.send?.payedAt ?? "-" }}</dd>
                </dl>
              </div>

              <div class="col-md-3">
                <dl>
                  <dt>Code</dt>
                  <dd>{{ transfer?.idOfSend ?? "-" }}</dd>
                </dl>
              </div>

              <div class="col-md-3">
                <dl>
                  <dt>provenAt</dt>
                  <dd>{{ transfer?.send?.provenAt ?? "-" }}</dd>
                </dl>
              </div>

              <div
                v-for="(receipt, i) in transfer.send.receipts"
                :key="receipt"
                class="col-md-3"
              >
                <dl>
                  <dt>Brouillon {{ i + 1 }}</dt>
                  <dd v-if="transfer?.receive?.proof">
                    <a :href="receipt" target="_blank">{{ receipt ?? "-" }}</a>
                  </dd>
                  <dd v-else></dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- APPROVE MODAL -->
    <b-modal
      v-model="doesApproveOpen"
      id="modal-center"
      centered
      size="md"
      title="Approuver la transfer"
      title-class="font-18"
      hide-footer
    >
      <form @submit.prevent="approuvetransfer()">
        <div class="row">
          <div class="col-md-12 mb-3">
            <label for="">Date de Paiement</label>
            <input
              type="datetime-local"
              required
              v-model="pay_date"
              class="form-control"
            />
            <span class="text-danger mt-2" v-if="errors.rate">{{ errors.pay_date }}</span>
          </div>
          <div class="col-md-12 mb-3">
            <label for="">ID de Paiement </label>
            <input type="text" required v-model="pay_id" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.rate">{{ errors.pay_id }}</span>
          </div>
        </div>
        <div class="mt-3" v-if="!loading">
          <input type="submit" value="Approuver" class="btn btn-success" />
        </div>
        <div class="mt-3 text-center" v-else>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- REJECT MODAL -->
    <b-modal
      v-model="doesRejectOpen"
      id="modal-center"
      centered
      size="md"
      title="Réjéter la transfer"
      title-class="font-18"
      hide-footer
    >
      <form @submit.prevent="rejecttransfer()">
        <div class="row">
          <div class="col-md-12 mb-3">
            <label for="">Raison du rejet</label>
            <textarea rows="3" required v-model="reason" class="form-control"></textarea>
            <span class="text-danger mt-2" v-if="errors.reason">{{ errors.reason }}</span>
          </div>
        </div>
        <div class="mt-3" v-if="!loading">
          <input type="submit" value="Réjéter" class="btn btn-danger" />
        </div>
        <div class="mt-3 text-center" v-else>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>
